import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: 'input[appRemoveLeadingZero]',
  standalone: true
})
export class RemoveLeadingZeroDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const initialVal = input.value;

    if (initialVal === '0') {
      return;
    }

    const newValue = initialVal.replace(/^0+/, '');

    input.value = newValue;

    /*input.dispatchEvent(new Event('input'));*/
  }

}
